import { Editor, Path, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { 
  setDefaults, 
  DEFAULTS_LIST,
  isBlockAboveEmpty,
  isCollapsed,
  isSelectionAtBlockStart,
  onKeyDownResetBlockType,
  getListNormalizer,
  getListItemEntry,
  removeFirstListItem,
  removeRootListItem,
  moveListItemUp,
  moveListItemDown,
  insertListItem,
  unwrapList,
  deleteFragmentList,
  match
} from '@udecode/slate-plugins'



export const getListTypes = (options) => {
  const { ul, ol } = setDefaults(options, DEFAULTS_LIST);

  return [ol.type, ul.type];
};

export const hasListChild = (node, options) =>
  node.children.some((n) => match(n, { type: getListTypes(options) }));

export const withList = ({
  validLiChildrenTypes,
  ...options
} = {}) => (editor) => {

  const { p, li } = setDefaults(options, DEFAULTS_LIST);
  const { insertBreak, deleteBackward, deleteFragment } = editor;

  const resetBlockTypesListRule = {
    types: [li.type],
    defaultType: p.type,
    onReset: (_editor) => unwrapList(_editor, options),
  };

  editor.insertBreak = () => {
    if (!editor.selection) return;

    const res = getListItemEntry(editor, {}, options);
    let moved;

    // If selection is in a li
    if (res) {
      const { list, listItem } = res;
      const [listItemNode, listItemPath] = listItem;

      const cursor = editor.selection.focus;

      if (hasListChild(listItemNode)) {
        /**
         * If selection is at the end of li,
         * insert below li where children will be moved.
         */
        if (Editor.isEnd(editor, cursor, listItemPath)) {
          return Transforms.insertNodes(
            editor,
            {
              type: li.type,
              children: [{ type: p.type, children: [{ text: '' }] }],
            },
            { at: Path.next(listItemPath), select: true }
          );
        }

        /**
         * If selection is at start of li,
         * insert above li.
         */
        if (Editor.isStart(editor, cursor, listItemPath)) {
          return Transforms.insertNodes(
            editor,
            {
              type: li.type,
              children: [{ type: p.type, children: [{ text: '' }] }],
            },
            { at: listItemPath }
          );
        }
      }

      /**
       * If selected li is empty, move it up.
       */
      if (isBlockAboveEmpty(editor)) {
        moved = moveListItemUp(
          editor,
          {
            list,
            listItem,
          },
          options
        );

        if (moved) return;
      }
    }

    // const didReset = onKeyDownResetBlockType({
    //   rules: [
    //     {
    //       ...resetBlockTypesListRule,
    //       predicate: () => !moved && isBlockAboveEmpty(editor),
    //     },
    //   ],
    // })(null, editor);
    // if (didReset) return;

    /**
     * If selection is in li > p, insert li.
     */
    if (!moved) {
      const inserted = insertListItem(editor, options);
      if (inserted) return;
    }

    insertBreak();
  };

  editor.deleteBackward = (unit) => {
    const res = getListItemEntry(editor, {}, options);

    let moved;

    if (res) {
      const { list, listItem } = res;
      const [listItemNode, listItemPath] = listItem;

      if (isSelectionAtBlockStart(editor)) {
        if (listItemPath[1] === 0) return;

        Editor.withoutNormalizing(editor, () => {
          moved = removeFirstListItem(editor, { list, listItem }, options);
          if (moved) return;

          moved = removeRootListItem(editor, { list, listItem }, options);
          if (moved) return;

          moved = moveListItemUp(editor, { list, listItem }, options);
        });
        if (moved) return;
      }

      if (hasListChild(listItemNode) && isCollapsed(editor.selection)) {
        return deleteBackward(unit);
      }
    }

    // const didReset = onKeyDownResetBlockType({
    //   rules: [
    //     {
    //       ...resetBlockTypesListRule,
    //       predicate: () => !moved && isSelectionAtBlockStart(editor),
    //     },
    //   ],
    // })(null, editor);

    // if (didReset) return;

    deleteBackward(unit);
  };

  editor.deleteFragment = () => {
    if (deleteFragmentList(editor, options)) return;

    deleteFragment();
  };

  editor.normalizeNode = getListNormalizer(
    editor,
    { validLiChildrenTypes },
    options
  );

  return editor;
};

